import { Tooltip } from '@sketch/components'
import React from 'react'
import { usePrototypeViewContext } from '../../hooks'
import * as Styles from './PrototypeFullScreenButton.styles'

export function PrototypeFullScreenButton() {
  const { enterFullscreen } = usePrototypeViewContext()
  return (
    <Tooltip placement="bottom" content="Enter Fullscreen">
      <Styles.EnterFullScreenButton
        data-testid="fullscreen-button"
        onClick={enterFullscreen}
        aria-label="FullScreen"
      >
        <Styles.FullScreenIcon />
      </Styles.EnterFullScreenButton>
    </Tooltip>
  )
}
